import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";

interface ITagInputProps {
  onTag: (tag: string) => Promise<void>;
  onEditarPlaca?: () => void;
  placa: string;
  loading: boolean;
}

export function TagInput({ onTag, onEditarPlaca, placa, loading }: ITagInputProps) {
  const [tag, setTag] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const prevLoadingRef = useRef(false);

  useEffect(() => {
    inputRef.current?.focus();
    return () => {
      if (timerRef.current) { clearTimeout(timerRef.current); }
    };
  }, []);

  useEffect(() => {
    if (prevLoadingRef.current && !loading) {
      // loading terminou (provavelmente erro) — refoca o campo
      inputRef.current?.focus();
    }
    prevLoadingRef.current = loading;
  }, [loading]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const valor = e.target.value;
    setTag(valor);
    if (timerRef.current) { clearTimeout(timerRef.current); }
    if (valor.trim().length > 0) {
      timerRef.current = setTimeout(() => {
        onTag(valor.trim());
        setTag("");
      }, 300);
    }
  }

  return (
    <div className="text-center py-3">
      {/* Placa grande */}
      <p className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>Placa registrada:</p>
      <div
        style={{
          display: "inline-block",
          border: "4px solid #1a1a1a",
          borderRadius: 12,
          padding: "10px 28px",
          background: "#fff",
          marginBottom: 8,
        }}
      >
        <span style={{ fontSize: "3.5rem", fontWeight: 800, letterSpacing: 8, fontFamily: "monospace", color: "#1a1a1a" }}>
          {placa}
        </span>
      </div>

      {onEditarPlaca && (
        <div className="mb-4">
          <button
            type="button"
            className="btn btn-link btn-sm p-0"
            style={{ fontSize: "0.8rem", color: "#6b7280" }}
            onClick={onEditarPlaca}
          >
            Placa errada? Corrigir
          </button>
        </div>
      )}

      {/* Campo da tag */}
      <p className="text-muted mb-2">Aproxime ou escaneie a tag QR code:</p>
      <input
        ref={inputRef}
        type="text"
        className="form-control text-center"
        style={{ fontSize: "1.4rem", fontWeight: 600, letterSpacing: 2, maxWidth: 300, margin: "0 auto" }}
        placeholder="Aguardando leitura..."
        value={tag}
        onChange={handleChange}
        disabled={loading}
        autoFocus
      />

      {loading && (
        <div className="text-center mt-3">
          <Spinner animation="border" size="sm" className="me-2" />
          <span>Vinculando tag...</span>
        </div>
      )}

      {onEditarPlaca && (
        <div className="mt-4">
          <PrimaryButton outline variante="primary" onClick={onEditarPlaca}>
            ← Voltar / Corrigir Placa
          </PrimaryButton>
        </div>
      )}
    </div>
  );
}
